import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import type { RootState } from '../../../reducers';
import { RouteParams } from '../types';
import MediaActions from './mediaActions';
import MediaActions2 from './mediaActions2';
import MultiFileChat from '../../chat/multi-file';
import { useUserTags } from '../../../hooks/useTags';
import { useSelectMode } from '../context/SelectModeContext';

export const LibraryActions = () => {
  const {
    library,
    upload,
    import: importState,
  } = useSelector((state: RootState) => state);
  const { teamId, folderId } = useParams<RouteParams>();
  const { selectedFiles, files } = library;
  const showSelectedFileActions = Object.keys(selectedFiles).length > 0;
  const { getTag } = useUserTags();
  const { selectMode, setSelectMode } = useSelectMode();

  const [templateModalOpen] = useState(false);

  // Get saved experience preference from user tags
  const savedExperience = getTag('media-actions-experience') as
    | 'classic'
    | 'new'
    | null;
  const useNewExperience = savedExperience === 'new';

  React.useEffect(() => {
    if (showSelectedFileActions && !selectMode) {
      setSelectMode(true);
    }
  }, [showSelectedFileActions, selectMode, setSelectMode]);

  if (
    !teamId ||
    !folderId ||
    (files.data.length === 0 &&
      !upload.activeUploads.length &&
      importState.status !== 'pending' &&
      files.status !== 'pending')
  ) {
    return (
      <div className="flex flex-col justify-between items-stretch h-auto">
        <div>{useNewExperience ? <MediaActions2 /> : <MediaActions />}</div>
        <div className="h-14 px-4" />
      </div>
    );
  }

  return (
    <div
      className="flex flex-col space-y-0 items-end mb-4"
      data-select-mode={selectMode}
    >
      {/* Media actions */}
      <div className="pb-0 w-full flex justify-end">
        {useNewExperience ? <MediaActions2 /> : <MediaActions />}
      </div>

      {templateModalOpen && <MultiFileChat open={templateModalOpen} />}
    </div>
  );
};

export default LibraryActions;
